import store from '@/store';
import MasterServices from "@/apiServices/MasterServices";
import UserService from '@/apiServices/UserService';

function initialState() {
  return {
    Countries: [],
    States: [],
    Cities: [],
    // Degrees: [],
    // Disciplines: [],
    CourseLevels: [],
    CourseCategories: [],
    SwedCourseCategories: [],
    UserTypes: [],
    Universities: [],
  }
}

const state = initialState();

const mutations = {
  ON_SET_COUNTRIES: (state, payload) => {
    state.Countries = payload
  },
  ON_SET_STATES: (state, payload) => {
    state.States = payload
  },
  ON_SET_CITIES: (state, payload) => {
    state.Cities = payload
  },
  ON_SET_COURSE_LEVELS: (state, payload) => {
    state.CourseLevels = payload
  },
  ON_SET_COURSE_CATEGORIES: (state, payload) => {
    state.CourseCategories = payload
  },
  ON_SET_SWED_COURSE_CATEGORIES: (state, payload) => {
    state.SwedCourseCategories = payload
  },
  ON_SET_USER_TYPES: (state, payload) => {
    state.UserTypes = payload
  },
  ON_SET_UNIVERSITIES: (state, payload) => {
    state.Universities = payload
  },
}

const actions = {
  onGetCountries: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_COUNTRIES', [])
    MasterServices.GetAllCountries({ ...payload, status: 'Y' })
      .then(async (response) => {
        const { data } = response.data
        if (response['data'] && response.data.status) {
          await commit('ON_SET_COUNTRIES', data)
        } else {
          store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
        }
      }).catch((error) => {
        console.error('Catch Error on onGetCountries', error);
      })

  },
  onGetStates: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_STATES', [])
    MasterServices.GetAllStates(payload)
      .then(async (response) => {
        const { data } = response.data
        if (response['data'] && response.data.status) {
          await commit('ON_SET_STATES', data)
        } else {
          store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
        }
      }).catch((error) => {
        console.error('Catch Error on onGetStates', error);
      })

  },
  onGetCities: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_CITIES', [])
    MasterServices.GetAllCities(payload)
      .then(async (response) => {
        const { data } = response.data
        if (response['data'] && response.data.status) {
          await commit('ON_SET_CITIES', data)
        } else {
          store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
        }
      }).catch((error) => {
        console.error('Catch Error on onGetCities', error);
      })
  },
  // onGetDegrees: async ({ dispatch, commit, state }, { ...payload }) => {
  //   await commit('ON_SET_DEGREES', [])
  //   MasterServices.GetAllDegrees(payload)
  //     .then(async (response) => {
  //       const { data: { data } } = response.data
  //       if (response['data'] && response.data.status) {
  //         await commit('ON_SET_DEGREES', data)
  //       } else {
  //         store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
  //       }
  //     }).catch((error) => {
  //       console.error('Catch Error on onGetDegrees', error);
  //     })
  // },
  // onGetDisciplines: async ({ dispatch, commit, state }, { ...payload }) => {
  //   await commit('ON_SET_DISCIPLINES', [])
  //   MasterServices.GetAllDisciplines(payload)
  //     .then(async (response) => {
  //       const { data: { data } } = response.data
  //       if (response['data'] && response.data.status) {
  //         await commit('ON_SET_DISCIPLINES', data)
  //       } else {
  //         store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
  //       }
  //     }).catch((error) => {
  //       console.error('Catch Error on onGetDisciplines', error);
  //     })
  // },
  onGetCourseLevels: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_COURSE_LEVELS', [])
    MasterServices.GetAllCourseLevels(payload)
      .then(async (response) => {
        const { data: { data } } = response;
        if (response['data'] && response.data.status) {
          await commit('ON_SET_COURSE_LEVELS', data)
        } else {
          store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
        }
      }).catch((error) => {
        console.error('Catch Error on onGetCourseLevels', error);
      })
  },
  onGetCourseCategories: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_COURSE_CATEGORIES', [])
    MasterServices.GetAllCourseCategories(payload)
      .then(async (response) => {
        const { data: { data } } = response;
        if (response['data'] && response.data.status) {
          await commit('ON_SET_COURSE_CATEGORIES', data)
        } else {
          store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
        }
      }).catch((error) => {
        console.error('Catch Error on onGetCourseCategories', error);
      })
  },
  onGetUserTypes: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_USER_TYPES', [])
    UserService.GetUserTypes()
      .then(async (response) => {
        const { data: { data } } = response;
        if (response['data'] && response.data.status) {
          await commit('ON_SET_USER_TYPES', data)
        } else {
          store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
        }
      }).catch((error) => {
        console.error('Catch Error on onGetUserTypes', error);
      })
  },
  onGetUniversities: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_UNIVERSITIES', [])
    MasterServices.GetUniversities(payload)
      .then(async (response) => {
        const { data } = response.data
        if (response['data'] && response.data.status) {
          await commit('ON_SET_UNIVERSITIES', data)
        } else {
          store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
        }
      }).catch((error) => {
        console.error('Catch Error on onGetCountries', error);
      })

  },

  // Swed
  onGetSwedCourseCategories: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_SWED_COURSE_CATEGORIES', [])
    MasterServices.GetAllSwedCourseCategories(payload)
      .then(async (response) => {
        const { data: { data } } = response;
        if (response['data'] && response.data.status) {
          await commit('ON_SET_SWED_COURSE_CATEGORIES', data)
        } else {
          store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
        }
      }).catch((error) => {
        console.error('Catch Error on onGetCourseCategories', error);
      })
  },
}

const getters = {
  getCountries: state => state.Countries,
  getStates: state => state.States,
  // getDegrees: state => state.Degrees,
  // getDisciplines: state => state.Disciplines,
  getCourseLevels: state => state.CourseLevels,
  getCourseCategories: state => state.CourseCategories,
  getSwedCourseCategories: state => state.SwedCourseCategories,
  getUserTypes: state => state.UserTypes,
  getUniversities: state => state.Universities,
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/MasterStore.js